"use client";

import {
  Config,
  HeaderContentAlignment,
  RoutesInfo,
  SessionStorageConstants,
  SessionStorageUtils,
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
  User,
} from "@thriwe-2-0/thriwe-ui-utils";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Hotline from "../(pages)/(dashboard)/profile/support/hotlineSupportModal";

import { useClientConfigProvider } from "../config/client-config-provider";
import { EventLabels } from "../constants/mix-panel-enums";
import AppRoutes from "../constants/routes";
import StringConstants from "../constants/string-contants";
import { useMixPanel } from "../context/mixPanelContext";
import RedirectToCard from "../utility/redirect";
import AddMembershipPopupDialog from "./dilaog/add-membership-popup-dialog";
import FallbackImage from "./FallbackImage";
import LanguageDropdown from "./header-component/LanguageSwitcher";
import MembershipPopup from "./header-component/membership-list-popup";
import { PopupMenu } from "./header-component/popup-menu";
import SearchInput from "./header-component/search-input";

type Category = {
  id: string;
  name: string;
  display_name: string;
  parent_id: number;
  parent_category: { name: string };
  images: {
    logo: string;
    cover_image_mobile: string;
    cover_image_web: string;
    display_image_mobile: string;
    display_image_web: string;
  };
  long_description: string;
  short_description: string;
  default_redemption_type: number;
  is_active: boolean;
};

export function getMenuItems(LoggedIn?: boolean, config?: Config | undefined) {
  const menuItems = config?.routes?.routesWithLogin;
  const menuItemsWithoutLogin = config?.routes?.routesWithoutLogin;
  if (LoggedIn) {
    return menuItems;
  } else {
    return menuItemsWithoutLogin;
  }
}

export default function Header({
  floatMenuRight = false,
}: {
  floatMenuRight?: boolean;
}) {
  const { config, getImagePath } = useClientConfigProvider();
  const isRestricted =
    config?.limitMaxSessions &&
    SessionStorageUtils.getFromSessionStorage(
      SessionStorageConstants.IS_MAX_SESSION_LIMIT_REACHED
    );
  const router = useRouter();
  const pathname = usePathname();
  const { t } = useTranslation();
  const context = useAppContext();
  const { trackEvent } = useMixPanel();
  const [showHotlineModal, setShowHotlineModal] = useState(false);
  const {
    state: { benefits, user },
    resetAppContext,
  } = context;

  const [isLogin, setIsLogin] = useState<boolean>(true);
  const [showAddMembershipPopup, setShowAddMembershipPopup] =
    useState<boolean>(false);

  useEffect(() => {
    const auth = !!UniversalStorageUtils.getItem(
      config?.nativeDataSavingType,
      UniversalStorageConstants.AUTH_TOKEN
    );

    setIsLogin(auth);
  }, []);

  const configFloatAlignment = !isLogin
    ? HeaderContentAlignment.Right
    : config?.header.contentAlign;

  return (
    <div className="headerBack">
      {showAddMembershipPopup && (
        <AddMembershipPopupDialog
          show={showAddMembershipPopup}
          closeModal={() => {
            setShowAddMembershipPopup(false);
          }}
        />
      )}
      <div
        className={`header-container ${
          pathname == AppRoutes.landing ? "" : "header-container-background"
        }`}
      >
        {!isRestricted && (
          <div className="d-block d-lg-none">
            {(isLogin || (getMenuItems(isLogin, config)?.length ?? 0) > 0) && (
              <Drawer
                user={context.state.user?.data!}
                isLogin={isLogin}
                showAddMembershipPopup={showAddMembershipPopup}
                setShowAddMembershipPopup={setShowAddMembershipPopup}
              />
            )}
          </div>
        )}
        <Image
          onClick={() => {
            router.push(AppRoutes.dashboard);
          }}
          src={getImagePath("logo.png")}
          alt=""
          width="300"
          height="300"
          className="logo-image"
        />
        {configFloatAlignment == HeaderContentAlignment.Right && (
          <div className="header-margin-between"></div>
        )}
        {!isRestricted && (
          <div
            className={`d-flex gap-item align-items-center ${
              !isLogin && "gap-item2"
            }  ${
              configFloatAlignment != HeaderContentAlignment.Right
                ? "header-right-align"
                : "header-left-align"
            }`}
          >
            {getMenuItems(isLogin, config)?.map((e: RoutesInfo) =>
              getMenuItemUI(e)
            )}

            {configFloatAlignment == HeaderContentAlignment.Left && (
              <div className="header-margin-between"></div>
            )}

            {config?.header.searchBar && isLogin && (
              <div className="d-none d-lg-block">
                <SearchInput />
              </div>
            )}

            {(pathname == AppRoutes.dashboard ||
              pathname == AppRoutes.dashboardListing) &&
            isLogin ? (
              <div>
                <MembershipPopup />
              </div>
            ) : (
              <div></div>
            )}
            <Hotline
              showHotlineModal={showHotlineModal}
              setShowHotlineModal={setShowHotlineModal}
            />
          </div>
        )}

        {!isLogin && (
          <div className="header-login">
            <div className="static_page_btn_section">
              <div className="static_page_btn_container">
                {process.env.NEXT_PUBLIC_PROJECT_CODE !== `HDFC_BUNDLE` &&
                  pathname != "/register" && (
                    <div className="static_page_btn_register_container">
                      <button
                        className=""
                        onClick={() => {
                          router.replace(AppRoutes.register);
                        }}
                      >
                        {t("header.Register")}
                      </button>
                    </div>
                  )}

                {pathname != "/login" && (
                  <div className="static_page_btn_register_login">
                    <button
                      className=""
                      onClick={() => {
                        router.replace(AppRoutes.login);
                      }}
                    >
                      {t("header.Login")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {config?.enableLanguageSwitch && <LanguageDropdown />}
        {!isRestricted && isLogin && (
          <div className="my-dropdown">
            <Dropdown
              className=""
              style={{ backgroundColor: "red" }}
              onSelect={(eventKey) => {
                console.log(`Selected option: ${eventKey}`);
              }}
            >
              <Dropdown.Toggle
                id="dropdown-basic"
                data-automation-id={`profile-dropdown`}
              >
                <UserImage
                  path={user?.data?.profilePictureURL ?? ""}
                  defaultImage={getImagePath("user-image-icon.png")}
                />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {config?.dropDownPopupMenu?.map((menu, index) => {
                  return (
                    <div key={index}>
                      <Dropdown.Item
                        eventKey="Option 4"
                        onClick={() => {
                          if (menu.isLogout) {
                            resetAppContext();
                            trackEvent(EventLabels.CTA_Logout, {
                              screen: "HeaderPopup",
                            });

                            setTimeout(() => {
                              router.push(AppRoutes.login);
                            }, 100);
                          } else {
                            router.push(menu?.path ?? "");
                          }
                        }}
                      >
                        <div className="d-flex gap-2 align-items-center pt-2 pb-2">
                          <div>
                            <Image
                              src={getImagePath(menu?.icon ?? "")}
                              alt=""
                              width={32}
                              height={32}
                              style={{
                                width: "auto",
                                height: "32px",
                              }}
                            />
                          </div>
                          <div
                            className="font-t-16 font-weight-t-600"
                            data-automation-id={`${menu.name}`}
                          >
                            {t("config_labels." + menu.name, menu.name ?? "")}
                          </div>
                        </div>
                      </Dropdown.Item>
                    </div>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
        {!isRestricted && config?.header.searchBar && isLogin && (
          <div className="d-block d-lg-none">
            <SearchInput />
          </div>
        )}
      </div>
    </div>
  );
  function getMenuItemUI(e: RoutesInfo) {
    function mergeCategoriesById(categories: any) {
      const result: any = {};

      // Step 1: Group categories by 'name'
      categories.forEach((category: Category) => {
        const { name } = category;

        if (!result[name]) {
          result[name] = [];
        }

        result[name].push(category);
      });

      // Step 2: Merge ids and return full data for each unique name
      return Object.entries(result).map(([name, groupedCategories]: any) => {
        const mergedIds = groupedCategories.map((cat: any) => cat.id).join("-");

        // Take the first item for the common data and add the merged ids
        const categoryData = { ...groupedCategories[0], id: mergedIds };

        return categoryData;
      });
    }

    if (e.isCategoryPopup) {
      return (
        <div key={e.name} className="menu-item-text d-none d-lg-block">
          <PopupMenu
            label={
              <div className="d-flex">
                <div>{t("config_labels." + e.name, e.name ?? "")}</div>
                <div>
                  <Image
                    src={getImagePath("arrow-down-black.png")}
                    alt="Search Icon"
                    width={15.81}
                    height={15.81}
                  />
                </div>
              </div>
            }
            popUpContent={(closePopup) => (
              <div className="membership-items">
                <div className="d-flex gap-4">
                  <div>
                    <div className="search-p-heading font-weight-t-400 mt-3">
                      {t("header.CATEGORIES")}
                    </div>
                    {mergeCategoriesById(benefits?.data?.categories ?? [])?.map(
                      (item, index) => {
                        return (
                          <div
                            className="d-flex gap-2 align-items-center pt-2 pb-2"
                            style={{ cursor: "pointer" }}
                            key={index}
                            onClick={() => {
                              let params = new URLSearchParams();
                              params.set(
                                StringConstants.PARAM_CATEGORY_ID,
                                item?.id ?? ""
                              );
                              router.replace(
                                `${AppRoutes.dashboard}?${params}`,
                                {
                                  scroll: false,
                                }
                              );
                              closePopup();
                            }}
                          >
                            <div>
                              <FallbackImage
                                src={item?.images?.logo ?? ""}
                                alt=""
                                width={32}
                                height={32}
                                style={{
                                  width: "auto",
                                  height: "32px",
                                  objectFit: "contain",
                                  backgroundColor:
                                    "var(--LightTheme-Background-primary_background)",
                                }}
                                fallbackSrc={
                                  "/common-images/category-placeholder-img.png"
                                }
                              />
                            </div>
                            <div className="font-t-16 font-weight-t-600">
                              {item?.display_name}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            )}
          />
        </div>
      );
    } else if (e.isBenefitsPopup) {
      return (
        <div key={e.name} className="menu-item-text d-none d-lg-block">
          <PopupMenu
            label={
              <div className="d-flex">
                <div>{t("config_labels." + e.name, e.name ?? "")}</div>
                <div>
                  <Image
                    src={getImagePath("arrow-down-black.png")}
                    alt="Search Icon"
                    width={15.81}
                    height={15.81}
                  />
                </div>
              </div>
            }
            popUpContent={(closePopup) => (
              <div className="membership-items">
                <div className="d-flex gap-4">
                  <div>
                    {(benefits?.data?.benefit_group_configs ?? []).map(
                      (item, index) => {
                        return (
                          <div
                            className="d-flex gap-2 align-items-center pt-2 pb-2"
                            style={{ cursor: "pointer" }}
                            key={index}
                            onClick={() => {
                              router.push(RedirectToCard(item));
                              closePopup();
                            }}
                          >
                            <div></div>
                            <div className="font-t-16 font-weight-t-600">
                              {item?.name}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            )}
          />
        </div>
      );
    } else {
      return (
        <div
          className={`d-none d-lg-block ${
            pathname != AppRoutes.landing ? "menu-item-text" : "menu-item-text2"
          }`}
          key={e.name}
          onClick={() => {
            if (e.isHelplinePopup) {
              setShowHotlineModal(true);
            }
            if (e.isMemberShipPopup) {
              setShowAddMembershipPopup(true);
            } else {
              router.push(e?.path ?? "");
            }
          }}
          style={{
            color:
              pathname == e.path ? "var(--LightTheme-Primary) !important" : "",
            cursor: "pointer",
          }}
        >
          {t("config_labels." + e.name, e.name ?? "")}
        </div>
      );
    }
  }
}
const Drawer = ({
  user,
  isLogin,
  showAddMembershipPopup,
  setShowAddMembershipPopup,
}: {
  user: User;
  isLogin?: boolean;
  showAddMembershipPopup: boolean;
  setShowAddMembershipPopup: Function;
}) => {
  const { config, getImagePath } = useClientConfigProvider();
  const { t } = useTranslation();

  const { trackEvent } = useMixPanel();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const pathname = usePathname();

  const [userProgressPercentage, setUserProgressPercentage] =
    useState<number>(10);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const context = useAppContext();
  const { resetAppContext } = context;

  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
  }, [user?.profilePictureURL]);

  useEffect(() => {
    if (user) {
      setUserProgressPercentage(calculateProfileCompletedPercentage(user));
    }
  }, [user]);

  function calculateProfileCompletedPercentage(userSession: User) {
    try {
      var totalFields = 9;
      var completedFields = 0;

      if (userSession?.firstName != null && userSession?.firstName != "") {
        completedFields++;
      }
      if (userSession?.lastName != null && userSession?.lastName != "") {
        completedFields++;
      }
      if (userSession?.email != null && userSession?.email != "") {
        completedFields++;
      }
      if (userSession?.phoneNumber != null && userSession?.phoneNumber != "") {
        completedFields++;
      }
      if (userSession?.gender != null && userSession?.gender != "") {
        completedFields++;
      }
      if (userSession?.dob != null && userSession?.dob) {
        completedFields++;
      }
      if (
        userSession?.profilePictureURL != null &&
        userSession?.profilePictureURL != ""
      ) {
        completedFields++;
      }
      if (userSession?.isMobileVerified ?? false) {
        completedFields++;
      }
      if (userSession?.isEmailVerified ?? false) {
        completedFields++;
      }

      const percentage = Math.floor((completedFields / totalFields) * 100);
      return percentage;
    } catch (error) {
      console.log("error");
    }
    return 10;
  }

  return (
    <div>
      <PopupMenu
        popUpClassName="drawer-popup category-popup-radius"
        bgClassName="blur-background"
        label={
          <div
            className="drawer-icon-style"
            onClick={() =>
              trackEvent(EventLabels.CTA_Hamburger, { screen: "Header" })
            }
          >
            <div>
              <Image
                src={getImagePath("drawer-icon.svg")}
                alt="Search Icon"
                width={23}
                height={23}
                className="drawer-image-style"
              />
            </div>
          </div>
        }
        selectedLabel={
          <div className="drawer-icon-style">
            <div>
              <Image
                src={getImagePath("close-menu.svg")}
                alt="Search Icon"
                width={23}
                height={23}
                className="drawer-image-style-s"
              />
            </div>
          </div>
        }
        popUpContent={(closePopup) => (
          <div>
            {isLogin && (
              <div className="popup-user-profile">
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    {!isError ? (
                      <Image
                        src={user?.profilePictureURL ?? ""}
                        alt=""
                        width="36"
                        height="36"
                        onError={() => {
                          setIsError(true);
                        }}
                        style={{
                          borderRadius: "36px",
                        }}
                      />
                    ) : (
                      <Image
                        src={getImagePath("profile-placeholder.png")}
                        alt=""
                        width="36"
                        height="36"
                      />
                    )}
                  </div>
                  <div className="w-100">
                    <div className="font-t-14 font-weight-t-500">{`${
                      user?.firstName ?? ""
                    } ${user?.lastName ?? ""}`}</div>
                    <div className="font-t-11 max-line-1">
                      {user?.email ?? ""}
                    </div>
                  </div>
                  <div
                    className="c-pointer"
                    onClick={() => {
                      router.push(AppRoutes.profileInfo);
                      closePopup();
                    }}
                  >
                    <Image
                      src={getImagePath("edit-icon.svg")}
                      alt=""
                      width={16.66}
                      height={16.66}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between mt-3">
                  <div className="font-t-9">Profile Completeness</div>
                  <div className="font-t-9">{userProgressPercentage}%</div>
                </div>
                <div
                  className="progress"
                  style={{ height: "5px", marginTop: "8px" }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${userProgressPercentage}%`,
                    }}
                  />
                </div>
              </div>
            )}
            <div>
              {getMenuItems(isLogin, config)
                ?.filter(
                  (route) =>
                    route.isCategoryPopup != true &&
                    route.isBenefitsPopup != true
                )
                ?.map((e: RoutesInfo) => (
                  <div
                    key={e.name}
                    className="d-flex popup-menu-item-container"
                  >
                    <div
                      className={`w-100 popup-menu-item-text font-t-16 font-weight-t-400`}
                      key={e.name}
                      onClick={() => {
                        if (e.isMemberShipPopup) {
                          setShowAddMembershipPopup(true);
                        } else {
                          router.push(e?.path ?? "");
                        }
                        closePopup();
                      }}
                      style={{
                        color:
                          pathname == e.path
                            ? "var(--LightTheme-Primary)"
                            : "var(--LightTheme-primary_text)",
                        cursor: "pointer",
                      }}
                    >
                      {t("config_labels." + e.name, e.name ?? "")}
                    </div>
                    <div>
                      <Image
                        src={getImagePath("arrow-right.svg")}
                        alt=""
                        width={20}
                        height={20}
                      />
                    </div>
                  </div>
                ))}
            </div>

            {isLogin && (
              <div
                className=""
                style={{
                  position: "absolute",
                  width: "90%",
                  bottom: "5%",
                  left: "50%",
                  transform: "translate(-50%)",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center logout-style c-pointer"
                  onClick={() => {
                    trackEvent(EventLabels.CTA_Logout, {
                      screen: "Hamburger",
                    });
                    resetAppContext();
                    setTimeout(() => {
                      router.push(AppRoutes.login);
                    }, 100);
                    closePopup();
                  }}
                >
                  <Image
                    src={getImagePath("logout-icon.png")}
                    alt=""
                    width={19}
                    height={19}
                  />
                  <div
                    className="popup-menu-item-text font-t-14 "
                    style={{ marginLeft: "10px" }}
                  >
                    {t("header.Logout")}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      />
    </div>
  );
};

export function UserImage({
  path,
  defaultImage,
}: {
  path: string;
  defaultImage: string;
}) {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(false);
  }, [path]);

  return (
    <div>
      {!isError ? (
        <Image
          key={path}
          src={path}
          alt=""
          width="34"
          height="34"
          className="header-user-image"
          onError={() => {
            setIsError(true);
          }}
        />
      ) : (
        <Image
          key={defaultImage}
          src={defaultImage}
          alt=""
          width="34"
          height="34"
          className="header-user-image"
        />
      )}
    </div>
  );
}
